import { createRoot } from 'react-dom/client';
import { createPortal } from 'react-dom';
import Toast from '../ToastBase';

const showToast = ({
  message,
  duration,
  onClose,
  loading
}: {
  message: string;
  duration?: number;
  onClose?: () => void;
  loading?: boolean;
}) => {
  try {
    const container = document.createElement('div');
    document.body.appendChild(container);
    const root = createRoot(container);

    const removeToast = () => {
      onClose?.();
      root.unmount();
      container.remove();
    };

    const ToastPortal = () => {
      return createPortal(
        <Toast
          message={message}
          duration={duration}
          onClose={removeToast}
          loading={loading}
        />,
        document.body
      );
    };

    root.render(<ToastPortal />);
  } catch (error) {
    console.error('Toast create error:', error);
  }
};

export default showToast;
